class ModeSwitcher<ModeType> {
  constructor(
    callback: (mode: ModeType) => void,
    identifier = '.js-view-modes',
    childIdentifier = '.js-view-mode-item input',
  ) {
    const menu = document.querySelector(identifier)

    if (!menu) {
      return
    }

    const options = menu.querySelectorAll<HTMLInputElement>(childIdentifier)

    for (const option of options)
      option.addEventListener('change', () => {
        for (const checked of menu.querySelectorAll('.selected')) checked.classList.remove('selected')
        option.parentElement?.classList.add('selected')
        callback(option.value as ModeType)
      })
  }
}

export default ModeSwitcher
